import { cn } from "@/lib/utils";
import type { ReactNode } from "react";

interface InputShellProps {
  children: ReactNode;
  className?: string;
}

/** Focus ring wrapper for ghost inputs (search, axis labels, inline editors). */
export function InputShell({ children, className }: InputShellProps) {
  return (
    <div
      className={cn(
        "flex items-center gap-1 bg-sands-50 border border-sands-200 rounded-lg pl-2 pr-1 py-1",
        "focus-within:ring-2 focus-within:ring-healing-300 focus-within:border-transparent",
        className,
      )}
    >
      {children}
    </div>
  );
}
